import { createFileRoute } from '@tanstack/react-router';
import { JourneysAudiencesSettingsHandoff } from '@/pages/workspaces/integrations/audiences/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

function JourneysAudiencesSettingsRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysAudiencesSettingsHandoff type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/integrations/audiences/$type/settings',
)({
  component: JourneysAudiencesSettingsRoute,
});
